<template>
  <div id="networking">
    <div class="content-wrapper">
      <portal to="action-buttons">
        <ul class="navbar-nav ml-md-auto">
          <li class="nav-item">
            <el-button
              icon="fas fa-plus"
              type="primary"
              size="small"
              round
              @click="
                updateForm = null;
                modalVisible = true;
              "
              
            >
              {{ $t("contentManagement.networking.addRoom") }}
            </el-button>
           
          </li>
        </ul>
      </portal>

      <div class="content animated fadeIn">
        <div class="card">
          <div class="card-header">
            <div class="card-title-container">
              <h5 class="card-title">{{ this.$t("event.menu.networkingrooms.title") }}</h5>
              <span v-if="$store.state.networking.items.length > 0 && $store.state.networking.items" v-html="$t('totalContent', [$store.state.networking.items.length])"></span>
            </div>

            <div class="header-elements">
              <el-button-group>
                <el-tooltip class="item" effect="dark" :content="$t('event.buttons.helpdesk')" placement="top">
                  <el-button @click="$helpMe(null)" icon="fas fa-life-ring" size="mini" round></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" :content="$t('event.buttons.refresh')" placement="top">
                  <el-button type="success" :icon="loading == 'loadingList' ? 'el-icon-loading' : 'fas fa-redo-alt'" size="mini" @click="refreshList" round></el-button>
                </el-tooltip>
              </el-button-group>
            </div>
          </div>

          <div class="card-body" v-if="false">
            <upgrade-overlay height="200px"></upgrade-overlay>
          </div>
          <div v-else-if="$store.state.networking.items.length > 0 && $store.state.networking.items">
            <div class="card-body">
              <div class="custom-grid-table-header networking-grid-template">
                <span><i v-show="loading == 'loadingList'" class="el-icon-loading"></i></span>
                <div>{{ $t("contentManagement.networking.room") }}</div>
                <div>{{ $t("contentManagement.networking.view") }}</div>
                <div></div>
              </div>
              <draggable :list="$store.state.networking.items" tag="div" handle=".el-icon-s-grid" class="list-group-o networking-container" v-bind="dragOptions" @start="dragList = true" @end="changeSort">
                <div class="item" v-for="item in $store.state.networking.items" :key="item.id" :class="{ passive: !item.isActive }">
                  <div class="table-icon">
                    <i class="burger" :class="loading == item.id ? 'el-icon-loading' : 'el-icon-s-grid'"></i>
                  </div>
                  <div class="img-title">
                    <div class="img" :style="'background-image:url(' + $imageus + item.cover + '?width=112&height=50&mode=cover)'"></div>
                    <div class="img-title-alt">
                      <div class="networking-area-title">
                        {{ item.title }}
                      </div>
                      <span>
                        <i class="fas fa-user-friends"></i>
                        {{ item.peopleCount }} {{ $t("contentManagement.networking.people") }}
                      </span>
                    </div>
                  </div>
                  <div><el-switch v-model="item.isActive" :disabled="loading == item.id" @change="toggleItem(item.id)"></el-switch></div>
                  <div class="action-btns">
                    <el-tooltip effect="dark" :content="$t('event.table.edit')" placement="top">
                      <el-button
                        type="primary"
                        icon="fas fa-pen"
                        circle
                        size="mini"
                        @click="
                          updateForm = item.id;
                          modalVisible = true;
                        "
                      ></el-button>
                    </el-tooltip>
                    <el-tooltip effect="dark" :content="$t('event.table.delete')" placement="top">
                      <el-popconfirm @confirm="deleteItem(item.id)" :confirmButtonText="$t('event.variables.yes')" :cancelButtonText="$t('event.buttons.cancel')" icon="el-icon-info" iconColor="red" :title="$t('event.textbox.toDelete')">
                        <el-button slot="reference" type="danger" :loading="loading == 'deleteItem-' + item.id" icon="fas fa-trash" circle size="mini"></el-button>
                      </el-popconfirm>
                    </el-tooltip>
                  </div>
                </div>
              </draggable>
            </div>
          </div>
          <div v-else>
            <HolaconLottieNoData
              class="w-100"
              key="create-loading"
              :source="'holacon-networking-lottie'"
              :title="$t('event.menu.networkingrooms.title')"
              @btnAdd="
                updateForm = null;
                modalVisible = true;
              "
              @btnRefresh="refreshList()"
              :buttonAdd="true"
              :buttonRefresh="true"
              :loading="loading"
            />
          </div>

          <div class="card-footer" ></div>
        </div>
      </div>
    </div>
    <el-dialog :close-on-click-modal="false" :visible.sync="modalVisible" :title="updateForm ? $t('contentManagement.networking.editNetworkRoom') : $t('contentManagement.networking.addNetworkRoom')" class="large" center modal-append-to-body destroy-on-close>
      <NetworkingAddUpdate @deleteMe="deleteItem" @closeDialog="modalVisible = false" :id="updateForm" v-if="modalVisible" />
    </el-dialog>
  </div>
</template>

<script>
import NetworkingAddUpdate from "../../components/NetworkingAddUpdate";
import ExcelImport from "../../components/ExcelImport";
import axios from "axios";
import $ from "jquery";
import PageCountInfo from "../../components/PageCountInfo";
import draggable from "vuedraggable";
export default {
  metaInfo() {
    return {
      title: this.$t("eventPageTitle.networking")
    };
  },
  components: { ExcelImport, PageCountInfo, NetworkingAddUpdate, draggable },
  name: "Networking",
  data() {
    return {
      modalVisible: false,
      updateForm: null,
      isFilterEnabled: false,
      timeout: null,
      dragList: false,
      excelDialog: false,
      loading: false,
      networkingShort: null,
      helpUrl: this.$helpUrl + "networking",
      widgetUrl: "https://cdn.holacon.com/widgets/event-speakers.html?applicationID=5e2b3b73286bd618b47d1e6e&amp;eventID=5e30227b83089521b86ef7bf",
      excelTemplateUrl: this.$excelTemplateUrl + "sample/SpeakerExcel/SpeakerImportSample.xlsx"
    };
  },
  methods: {
    itemUpdated(item) {
      var index = this.$store.state.networking.items.findIndex(k => k.id == item.id);
      if (index != -1) {
        this.$store.state.networking.items.splice(index, 1, item);
      }
    },
    itemAdded(item) {
      this.$store.dispatch("getNetworkings");
    },
    handleSizeChange(take) {
      this.$store.commit("setNetworkingTake", take);
    },
    handleCurrentChange(page) {
      $("html, body").animate({ scrollTop: 0 }, 350);
      this.$store.commit("setNetworkingPage", page);
    },
    changeSort() {
      if (this.networkingShort != null) clearTimeout(this.networkingShort);
      this.loading = "loadingList";
      this.networkingShort = setTimeout(async () => {
        var payload = [];
        this.$store.state.networking.items.map(x => {
          payload.push(x.id);
        });
        await this.$store.dispatch("saveNetworkingOrder", payload);
        await this.$store.dispatch("getNetworkings");
        this.loading = false;
      }, 500);
    },
    async refreshList() {
      if (this.listShort != null) clearTimeout(this.listShort);
      this.loading = "loadingList";
      await this.$store.dispatch("getNetworkings");
      this.listShort = setTimeout(async () => {
        this.loading = false;
      }, 500);
    },
    async toggleItem(id) {
      this.loading = id;
      await this.$store.dispatch("toggleNetworking", id);
      setTimeout(() => {
        this.loading = false;
      }, "500");
    },
    deleteItem(id) {
      this.loading = "deleteItem-" + id;
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        var res = await this.$store.dispatch("deleteNetworking", id);
        if (!res.data.alert.hasError) {
          await this.$store.dispatch("getNetworkings");
        }
        this.loading = false;
      }, 500);
    },
    statusChanged(value, index) {
      this.$store.dispatch("toggleNetworking", { index, value });
    },
    handleSelectionChange(items) {
      this.$store.commit("setSelectedNetworkings", items);
    },
    tableRowClassName({ row, rowIndex }) {
      if (row.isActive) {
        return "row-active";
      }
      return "row-passive";
    }
  },
  async mounted() {
    this.loading = "loadingScreen";
    if (this.timeout != null) clearTimeout(this.timeout);
    this.timeout = setTimeout(async () => {
      await Promise.all([this.$store.dispatch("getNetworkings"), this.$store.dispatch("getVenues")]);
      this.loading = false;
    }, 500);
  },
  created() {},
  computed: {
    eventPermissions() {
      return this.$store.getters.getEventPermission;
    },
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost"
      };
    },
    skip() {
      return (this.$store.state.networking.filter.page - 1) * this.$store.state.networking.filter.take;
    },
    take() {
      return this.skip + this.$store.state.networking.items.length;
    }
  },
  watch: {
    "$store.state.networking.filter.searchTerm": function() {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.$store.dispatch("getNetworkings");
      }, 500);
    }
  }
};
</script>
<style lang="less" scoped>
.networking-grid-template {
  grid-template-columns: 36px 1fr 90px 90px;
}
.networking-container {
  display: flex;
  flex-direction: column;
  .item {
    margin-bottom: 8px;

    &:last-child {
      margin-bottom: unset;
    }
    .img-title {
      display: flex;
      gap: 1rem;
      font-weight: 500;
      align-items: center;
      .img-title-alt {
        display: flex;
        flex-direction: column;
        .networking-area-title {
          font-size: 14px;
          color: #292f3b;
          font-weight: 600;
          line-height: normal;
        }
        span {
          font-size: 13px;
          display: block;
          font-weight: 500;
          color: #505763;
          line-height: normal;

          & > i {
            font-size: 13px;
            color: #03658c;
          }
        }
      }
      & > .img {
        border-radius: 8px;
        width: 112px;
        height: 50px;
        background-size: cover;
        background-position: center center;
        background-repeat: no-repeat;
        overflow: hidden;
        border: 3px solid white;
      }
    }
    transition: all 0.5s;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    background-color: #f1f1f1;
    &.passive {
      background-color: #fff2f2 !important;
    }
    display: grid;
    grid-template-columns: 36px 1fr 90px 90px;
    padding: 10px;
    align-items: center;
    border-radius: 8px;
    transition: all 0.5s;

    & > .price-title {
      font-weight: bold;
      flex-direction: row;
      gap: 0.5rem;
      .el-input {
        width: 100%;
      }
    }
    .el-input-number {
      width: 100%;
    }
    .el-date-editor {
      width: 100%;
    }
    i.burger {
      box-sizing: border-box;
      font-size: 20px;
      color: #505763;
      cursor: grab;
      &.me {
        color: #ccc;
      }
    }
    & > .title {
      flex-shrink: 0;
      display: flex;
      flex-direction: column;
      align-items: center;

      & > i.el-icon-loading {
        font-size: 20px;
      }
    }

    & > div:last-child {
      justify-self: flex-end;
    }
    .table-icon {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      font-weight: bold;
    }
  }
}
.model-base-small {
  min-width: 550px;
}
</style>



// WEBPACK FOOTER //
// src/pages/event/Networking.vue